import accountSetRoute from "./modules/accountSet";
import userCenterRoute from "./modules/userCenter";
import messageManageRoute from "./modules/messageManage";
import financialManageRoute from "./modules/financialManage";
import receptionHall from "./modules/receptionHall";
// 公共路由（无需权限）
const constantRoutes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/home/index.vue"),
    meta: { title: "首页", activeIndex: 1 },
  },
  {
    path: "/404",
    name: "NotFound",
    component: () => import("@/views/error/404.vue"),
    meta: { title: "404", activeIndex: 0 },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
    meta: {
      activeIndex: 0,
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/register/index.vue"),
    meta: {
      activeIndex: 0,
    },
  },
];

// 动态路由（需要权限）
const asyncRoutes = [
  ...accountSetRoute,
  ...userCenterRoute,
  ...messageManageRoute,
  ...financialManageRoute,
  ...receptionHall,
  // 404页面必须放在最后
  { path: "*", redirect: "/404", hidden: true },
];

export default [...constantRoutes, ...asyncRoutes];
